import React from 'react'
import { useProductDetailContext } from '@core/utils/models/product/ProductContext'
import LastViewedProductsSlider from '@core/components/shared/RecommendationSlider/LastViewedProductsSlider'

const LastVisitedPDPsRecommendations: React.FC = () => {
  const { variant } = useProductDetailContext() || {}
  return <LastViewedProductsSlider variantId={variant?.id} />
}

export default LastVisitedPDPsRecommendations
